<template>
  <b-form @submit="onSubmit" @reset="onReset">
    <div style="display: flex; flex-direction: column; gap: 50px">
      <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
        cannot Registration
      </b-alert>
      <div class="m-card">
        <div
          style="
            display: flex;
            justify-content: center;
            gap: 20px;
            align-items: center;
          "
          class="flex-vertical"
        >
          <div style="display: flex; flex-direction: column">
            <div style="text-align: center; font-weight: 700">
              Scan Tag Barcode
            </div>
            <div style="display: flex; align-items: center; gap: 10px">
              <div>
                <scan-qr-code @update-tag="updateTag" />
              </div>
              <div>
                <b-form-input
                  v-model="info.mac"
                  placeholder="Enter Tag"
                  required
                  :disabled="!isRegis"
                ></b-form-input>
              </div>
            </div>
          </div>
          <div
            style="
              font-size: 1.5em;
              color: #32c040;
              font-weight: 700;
              display: flex;
              align-items: center;
            "
          >
            Then
          </div>
          <div style="display: flex; flex-direction: column">
            <div style="text-align: center; font-weight: 700">
              Capture Visitor Image
            </div>
            <div style="display: flex; align-items: center; gap: 10px">
              <div
                style="
                  border: 1px solid #707070;
                  border-radius: 20px;
                  padding: 5px;
                  display: flex;
                  align-items: center;
                "
              >
                <span class="material-icons-outlined"> badge </span>
              </div>
              <div>
                <!-- <b-button variant="outline-primary">Camera</b-button> -->
                <webcam @capimg="capimg" />
              </div>
            </div>
          </div>
          <div>
            <img :src="img" alt="" srcset="" height="55" />
          </div>
        </div>
      </div>
      <div class="m-card" style="padding: 50px 30px 30px 30px">
        <div
          class="m-card"
          style="
            background: #5dbb66;
            color: #fff;
            font-size: 1.5em;
            font-weight: 600;
            position: absolute;
            top: -25px;
            left: 30px;
            display: flex;
            flex-direction: row;
          "
        >
          <div>Visitor Registration</div>
        </div>
        <div>
          <!-- <b-form @submit="onSubmit" @reset="onReset"> -->
          <b-form-group
            id="input-group-1"
            label="Visitor Name"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="info.visitor"
              type="text"
              placeholder="Visitor Name"
              required
            ></b-form-input>
          </b-form-group>
          <b-row class="m-0">
            <b-col class="pr-2">
              <b-form-group
                id="input-group-2"
                label="Company"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="info.company"
                  type="text"
                  placeholder="Company"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col class="pr-2">
              <b-form-group
                id="input-group-3"
                label="Department"
                label-for="input-3"
              >
                <b-form-input
                  id="input-3"
                  v-model="info.department"
                  type="text"
                  placeholder="Department"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-4"
                label="Acknowledged Timestamp"
                label-for="input-4"
              >
                <!-- <div style="display: flex; align-items: flex-start; gap: 5px">
                  <b-form-datepicker
                    id="example-datepicker"
                    v-model="dateAck"
                    class="mb-2"
                  ></b-form-datepicker>
                  <b-form-timepicker
                    v-model="timeAck"
                    :hour12="false"
                  ></b-form-timepicker>
                </div> -->
                <b-form-input
                  id="input-4"
                  v-model="info.ack"
                  type="text"
                  placeholder="Acknowledged Timestamp"
                  required
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="m-0">
            <b-col class="pr-2">
              <b-form-group
                id="input-group-5"
                label="Visitor Target Location"
                label-for="input-5"
              >
                <b-form-select
                  id="input-5"
                  v-model="info.target"
                  :options="options_location"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col class="pr-2">
              <b-form-group
                id="input-group-6"
                label="Limit Duration Time"
                label-for="input-6"
              >
                <b-form-select
                  id="input-6"
                  v-model="info.limit"
                  :options="options_duration_time"
                  @change="changeLimit"
                ></b-form-select>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                id="input-group-7"
                label="Time Limit"
                label-for="input-7"
              >
                <!-- <div style="display: flex; align-items: flex-start; gap: 5px">
                  <b-form-datepicker
                    id="example-datepicker"
                    v-model="value"
                    class="mb-2"
                  ></b-form-datepicker>
                  <b-form-timepicker
                    v-model="value"
                    :hour12="false"
                  ></b-form-timepicker>
                </div> -->
                <b-form-input
                  id="input-7"
                  v-model="info.timelimit"
                  type="text"
                  placeholder="Time Limit"
                  required
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <div>
            <b-form-group
              id="input-group-8"
              label="Description"
              label-for="input-8"
            >
              <b-form-textarea
                id="input-8"
                v-model="info.description"
                placeholder="Description"
                rows="3"
              ></b-form-textarea>
            </b-form-group>
          </div>
          <!-- <b-form-file v-model="file2" class="mt-3" plain></b-form-file> -->
          <div style="display: flex; justify-content: center; gap: 20px">
            <b-button type="submit" variant="success">{{
              isRegis ? "Submit" : "Edit"
            }}</b-button>
            <b-button type="reset" variant="light">Clear</b-button>
          </div>
          <!-- </b-form> -->
        </div>
      </div>
    </div>
  </b-form>
</template>

<script>
import ScanQrCode from "./components/scanQrCode.vue";
import Webcam from "./components/webcam.vue";
export default {
  components: {
    Webcam,
    ScanQrCode,
  },
  data() {
    return {
      selected_location: null,
      options_location: [
        { value: "", text: "Please select an option" },
        { value: "lobby", text: "Lobby" },
        { value: "meeting_room_1", text: "Meeting Room 1" },
        // { value: "meeting_room_2", text: "Meeting Room 2" },
      ],
      selected_duration_time: null,
      options_duration_time: [
        { value: "", text: "Please select an option" },
        { value: "60", text: "1 hr." },
        { value: "120", text: "2 hrs." },
        { value: "180", text: "3 hrs." },
        { value: "240", text: "4 hrs." },
      ],
      showDismissibleAlert: false,
      type: "register",
      isRegis: true,
      dateAck: this.$moment().format("YYYY-MM-DD HH:mm"),
      timeAck: "",
      img: null,
      info: {
        mac: "",
        visitor: "",
        company: "",
        department: "",
        target: "",
        limit: "",
        description: "",
        ack: "",
        timelimit: "",
      },
    };
  },
  mounted() {
    console.log(this.$route);
    this.type = this.$route.name == "mhesi-register" ? "register" : "edit";
    this.isRegis = this.$route.name == "mhesi-register" ? true : false;
    if (this.info.ack == "")
      this.info.ack = this.$moment().format("YYYY-MM-DD HH:mm");

    if (!this.isRegis) {
      let tag = this.$session.get("tag");
      tag.ack = this.$moment(tag.ack)
        .subtract(7, "hours")
        .format("YYYY-MM-DD HH:mm");
      tag.timelimit = this.$moment(tag.timelimit)
        .subtract(7, "hours")
        .format("YYYY-MM-DD HH:mm");
      this.info = tag;
      console.log(tag);
    }
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      console.log(this.info);
      if (this.isRegis) {
        try {
          this.$API.post("indoor/assetinfo", this.info).then((res) => {
            console.log(res);
            if ((res.data = "OK")) {
              if (this.img != null) {
                this.uploadimg();
              } else {
                this.$router.push("/mhesi/location");
              }
            }
          });
        } catch (error) {
          this.showDismissibleAlert = true;
        }
      } else {
        try {
          //  let res = await this.$API().post()
          this.$API.put("indoor/assetinfo", this.info).then((res) => {
            console.log(res);
            if ((res.data = "OK")) {
              if (this.img != null) {
                this.uploadimg();
              } else {
                this.$router.push("/mhesi/location");
              }
            }
          });
        } catch (error) {}
      }
    },
    onReset(event) {
      event.preventDefault();
      this.info = {
        mac: "",
        visitor: "",
        company: "",
        department: "",
        target: "",
        limit: "",
        description: "",
        ack: this.$moment().format("YYYY-MM-DD HH:mm"),
        timelimit: "",
      };
    },
    changeLimit() {
      this.info.timelimit = this.$moment(this.info.ack)
        .add(this.info.limit, "minute")
        .format("YYYY-MM-DD HH:mm");
    },
    capimg(img) {
      console.log("capimg");
      this.img = img;
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    uploadimg() {
      let file = this.dataURLtoFile(this.img, "visitor");
      const formData = new FormData();
      formData.append("files", file);
      formData.append(
        "visitor",
        new Blob([this.info.visitor], { type: "text/plain" })
      );
      console.log(formData, file);
      this.$API.post("upload/MHESI", formData).then(() => {
        console.log("uploadimg success");
        this.$router.push("/mhesi/location");
      });
    },
    updateTag(content) {
      this.info.mac = content;
    },
  },
};
</script>

<style lang="scss" scoped>
.flex-vertical {
}

@media screen and (max-width: 600px) {
  .flex-vertical {
    flex-direction: column;
  }
}
</style>